import React from "react";
import {Col, Row, Typography} from "antd";
import {getConfig} from "../../../../components/permissions/functions";
import {useSelector} from "react-redux";
import AccessAttrAvatars from "../../../../components/custom-fields/AccessAttrAvatars";

const {Text, Title} = Typography

export function FicheAccess(props) {

    const org = useSelector(_state => _state.auth.org)

    const {selected, fiche} = props

    if (!selected) {
        return null
    }

    const isAttrSystem = getConfig("AttrSystem", "CONFIG")

    if (!isAttrSystem) {
        return null
    }

    return (
        <Col style={{marginBottom: 20}}>
            <Row style={{flexWrap: "wrap", justifyContent: "flex-end", marginBottom: 10}}>
                <AccessAttrAvatars
                    id={selected.id}
                    accessAttr={selected.accessAttr || []}
                    accessType={"CONTACT"}
                    onChange={() => {
                        fiche.getData()
                    }}
                    withRoles={true}
                />
            </Row>
        </Col>
    )
}
